export default {
    title: "Recommandations du conseiller",
    noItems: "Aucune recommandation"
}